const navbar = {
  packages: "Πακέτα", // translated
  experiences: "εμπειρίες", // translated
  close: "Κλείσιμο", // translated
  hotelPackages: "Πακέτα ξενοδοχείων", // translated
  hotDeals: "Καυτές προσφορές", // translated
  pricing: "Τιμολόγηση", // translated
  dashboard: "Ταμπλό", // translated
};


export default navbar;
